export default function customerReducer(state=[], action) {
    return state
}